import { render } from "./SelectedTariff.vue?vue&type=template&id=6eb024a6"
import script from "./SelectedTariff.vue?vue&type=script&lang=js"
export * from "./SelectedTariff.vue?vue&type=script&lang=js"

import "./SelectedTariff.vue?vue&type=style&index=0&id=6eb024a6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__